<template>
  <div>
    <table
      v-if="loading == false"
      class="uk-table metatrader-accounts-table uk-table-hover uk-table-divider"
    >
      <thead>
        <tr>
          <th>LOGIN</th>
          <th>SYMBOL</th>
          <th>ACTION</th>
          <th>VOLUME</th>
          <th>Time Setup</th>
          <th>Price Order</th>
          <th>Price SL</th>
          <th>Price TP</th>
          <th>Price Current</th>
        </tr>
      </thead>
      <tbody v-if="results">
        <tr :key="result.Order" v-for="result in results">
          <td>
            <b>{{ result.Login }}</b>
          </td>
          <td>
            <b>{{ result.Symbol }}</b>
          </td>
          <td>{{ actionKey[result.Type] }}</td>
          <td>{{ result.VolumeCurrent / 1000 }}</td>

          <td>
            {{ result.TimeSetup | formatDate }}
          </td>
          <td>{{ result.PriceOrder }}</td>
          <td>{{ result.PriceSL }}</td>
          <td>{{ result.PriceTP }}</td>
          <td>{{ result.PriceCurrent }}</td>
        </tr>
      </tbody>
    </table>

    <div class="center flex items-center justify-center" v-else>
      <vk-spinner></vk-spinner>
    </div>
  </div>
</template>

<script>
import EventBus from "../../../../components/Ui/EventBus";
import http from "../../../../services/http";
export default {
  props: ["login", "type"],
  data() {
    return {
      loading: true,
      results: [],
      actionKey: ["Alış", "Satış", "Alış Limit", "Satış Limit"],
    };
  },
  methods: {
    getData() {
      http.mt5
        .getUserPendingOrders({ login: this.login, type: this.type })
        .then((e) => {
          this.results = e.data.result;
          this.loading = false;
        });
    },
  },
  mounted() {
    EventBus.$on("Services.orders", (login) => {
      this.getData(login);
    });
    this.getData();
  },
};
</script>

<style></style>
